import React from "react";
import Heading from "@unum/heading";
import { TwoColumnVideoProps } from "./types";
import VideoEmbed from "@unum/video-embed";
import classnames from "classnames";
import styles from "./Hero.module.scss";

const TwoColumnVideo = ({
  title,
  children,
  ctas,
  videoUrl,
  videoLabel
}: TwoColumnVideoProps) => {
  return (
    <div className={classnames(styles["Hero"], "hero hero-help")}>
      <div className="spring">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <Heading
              level={1}
              className="hero__heading--alt hero-help__heading"
            >
              {title}
            </Heading>
            <div className="col-sm-11">
              <div className="hero-help__description">
                {children}
                {ctas}
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-md-6">
            <VideoEmbed videoUrl={videoUrl} accessibilityLabel={videoLabel} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TwoColumnVideo;
